module.exports = "<md-step-title [form]=\"form\"></md-step-title> <md-formfactory [form]=\"form\" (updateBtnClicked)=\"btnClick($event)\"> </md-formfactory> ";